import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, type FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { TIMESHEET_STATUS } from '../../../constant/constant';
import { ActivityService } from '../../../services/acitvity.service';
import { CategoryService } from '../../../services/category.service';
import { TimesheetService } from '../../../services/timesheet.service';
import { UserService } from '../../../services/user.service';
import { ExportExcel } from '../../../constant/ExcelExport';
import saveAs from 'file-saver';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TimesheetListComponent } from '../../timesheet-list/timesheet-list.component';
import type { ResponseForReport } from '../../../constant/response';
import type { CategoryReport } from '../../../constant/categoryReport';
import { MultiSelectSearch } from '../../../helper/MultiSelectSearch';
import { HttpErrorResponse } from '@angular/common/http';
import { Category } from '../../../dtos/Category';
import { ResponseCommonForList } from '../../../dtos/ResponseDTOs';
import { Activity } from '../../../dtos/Activity';
import type { IdName } from '../../../dtos/IdName';
import { RoleEnum } from '../../../enums/role.enum';


export interface UserReport {
  userId: number,
  fullName: string,
  noOfHours: number
}
@Component({
  selector: 'app-user-report',
  templateUrl: './user-report.component.html',
  styleUrl: './user-report.component.css',
  standalone: false
})
export class UserReportComponent {

  @ViewChild(TimesheetListComponent) timeSheetListCompo : any;
  userData: any;
  categoryList: Category[] = [];
  activityList: Activity[] = [];
  usersForFilter: IdName[] = [];
  filterActivityList: Activity[] = [];
  filterForm: FormGroup;
  timeSheetStatus: { id: number, name: string }[] = TIMESHEET_STATUS;
  activities: Activity[] = [];
  dataSource = new MatTableDataSource<UserReport>([]);

  userReport: UserReport[] = [];
  totalHours: number = 0;
  isAdmin: boolean = false;
  isTeamlead: boolean = false;
  isDepartmentAdmin: boolean = false;

  @Output() isExcelBeingDownloaded = new EventEmitter<boolean>();
  isExcelExporting: boolean = false;
  exportButtonText: string = 'Export User Report';

  displayedColumns: string[] = ['fullName', 'workDate', 'day', 'noOfHours', 'workDetails', 'status', 'actions'];

  categorySearch: MultiSelectSearch<IdName>;
  activitySearch: MultiSelectSearch<IdName>;
  userSearch: MultiSelectSearch<IdName>;
  statusSearch: MultiSelectSearch<IdName>;


  constructor(
    private userService: UserService,
    private categoryService: CategoryService,
    private activityService: ActivityService,
    private timesheetService: TimesheetService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    public datePipe: DatePipe,
    private exportData: ExportExcel,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.filterForm = this.formBuilder.group({
      workDate: [''],
      categoryIds: [[],],
      activityIds: [[],],
      userIds: [[],],
      status: [[],],
      startDate: [''],
      endDate: ['']
    });

    this.categorySearch = new MultiSelectSearch<IdName>(this.filterForm.get('categoryIds') as FormControl, [], (value) => this.onfilterCategorySelection(value));
    this.activitySearch = new MultiSelectSearch<IdName>(this.filterForm.get('activityIds') as FormControl,[]);
    this.userSearch = new MultiSelectSearch<IdName>(this.filterForm.get('userIds') as FormControl, []);
    this.statusSearch = new MultiSelectSearch<IdName>(this.filterForm.get('status') as FormControl, this.timeSheetStatus);
  }

  ngOnInit(): void {
    this.getStorageData();
    this.getAllUserIdNameForFilter();
    this.filterForm.get("startDate")?.reset();
    this.filterForm.get("endDate")?.reset();
    this.getAllCategory();
    this.filterForm.get("startDate")?.setValue(moment());
    this.filterForm.get("endDate")?.setValue(moment());
    this.getUserReport();
  }

  getStorageData() {
    let user: any = sessionStorage.getItem("userData");
    this.userData = JSON.parse(user);
    this.isAdmin = Number(this.userData.roleId) == RoleEnum.ADMIN;
    this.isTeamlead = Number(this.userData.roleId) == RoleEnum.TEAMLEAD;
    this.isDepartmentAdmin = Number(this.userData.roleId) == RoleEnum.DEPARTMENT_ADMIN;
  }


  getAllUserIdNameForFilter(): void {
    this.userService.getUserIdNameList().subscribe({
      next: (res: ResponseCommonForList<IdName>) => {
        this.usersForFilter = res.responseObject;
        this.userSearch.setOptions(this.usersForFilter);
      },
      error: (err: HttpErrorResponse) => {
        console.error("Error getting UserIdNameList for Filter", err.message);
      }
    });
  }

  onfilterCategorySelection(categoryIds: number[]): void {
    if (categoryIds && categoryIds.length > 0) {
      const categoryTypeIds = this.categoryList.filter(c => categoryIds.includes(c.id)).map(category => category.categoryTypeId);
      this.getFilterActivityList(categoryTypeIds);
    } else {
      this.filterActivityList = [];
      this.filterForm.get('activityIds')?.reset();
    }
  }

  getAllCategory(): void {
    this.categoryService.getAllCategory().subscribe({
      next: (res: ResponseCommonForList<Category>) => {
        this.categoryList = res.responseObject;
        this.categorySearch.setOptions(this.categoryList.map((c: IdName) => ({ id: c.id, name: c.name })));
      },
      error: (err: HttpErrorResponse) => {
        console.error("Error getting List of Category", err.message);
      }
    });
  }

  getFilterActivityList(categoryTypeIds: number[]): void {
    this.activityService.getActivityByCategoryTypeIds(categoryTypeIds).subscribe({
      next: (res: ResponseCommonForList<Activity>) => {
        this.filterActivityList = res.responseObject;
        this.activitySearch.setOptions(this.filterActivityList.map((a: IdName) => ({id: a.id, name: a.name})));
        if (this.filterActivityList.length == 1 && this.filterForm.get("categoryIds")?.value != null) {
          this.filterForm.get("activityIds")?.setValue(this.filterActivityList[0].id)
        } else {
          this.filterForm.get("activityIds")?.reset()
        }
      },
      error: (err: HttpErrorResponse) => {
        console.error("Error getting activityList by categoryTypeIds : ", err.message);
      }
    });
  }

  getActivityListByCategoryType(categoryTypeId: number): void {
    this.activityService.getActivityByCategoryTypeId(categoryTypeId).subscribe({
      next: (res: ResponseCommonForList<Activity>) => {
        this.activities = res.responseObject;
      },
      error: (err: HttpErrorResponse) => {
        console.error("Error getting Activities By CategoryTypeId:", err.message);
      }
    });
  }

  getUserReport() {
  const filterData = this.filterForm.value;

  filterData.workDate = this.datePipe.transform(filterData.workDate, 'yyyy-MM-dd');
  filterData.startDate = this.datePipe.transform(filterData.startDate, 'yyyy-MM-dd');
  filterData.endDate = this.datePipe.transform(filterData.endDate, 'yyyy-MM-dd');
  filterData.userIds = this.filterForm.get('userIds')?.value;

   if (!filterData.userIds || filterData.userIds.length === 0) {

    if (this.isTeamlead || this.isDepartmentAdmin) {
      this.filterForm.patchValue({
          userIds: [this.userData.id]
      });
      filterData.userIds = [this.userData.id];
    } else if (!this.isAdmin) { // Employee -> always themselves
      filterData.userIds = [this.userData.id];
    }
  }

  this.timesheetService.getUserReport(filterData).subscribe({
    next: (res: ResponseForReport<UserReport>) => {
      this.userReport = res.responseObject || [];

      this.totalHours = this.userReport.reduce(
        (sum, item) => sum + Number(item.noOfHours || 0),
        0
      );

      this.userData.data = this.userReport;

      this.snackBar.open(res.message, 'Close', {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center'
      });
    }
  });

  // (response => {
  //   this.userReport = response.responseObject;
  //   this.dataSource.data = [...this.userReport];
  // })
}
  currentDate = new Date();
  formatedDate: string | null = this.datePipe.transform(this.currentDate, 'dd_MM_yyyy_HH_mm');

  exportUserReprot(): void {
    let userId = this.userData.id;
    const filterData = this.filterForm.value;
    filterData.workDate = this.datePipe.transform(filterData.workDate, 'yyyy-MM-dd');
    filterData.startDate = this.datePipe.transform(filterData.startDate, 'yyyy-MM-dd');
    filterData.endDate = this.datePipe.transform(filterData.endDate, 'yyyy-MM-dd');
    filterData.userIds = this.filterForm.get('userIds')?.value;
    if (this.isAdmin) {
      userId = -1;
    }
    if (!this.isAdmin && !this.isTeamlead && !this.isDepartmentAdmin) {
      filterData.userIds = [this.userData.id];
    }
    this.isExcelBeingDownloaded.emit(true);
    this.timesheetService.exportUserReport(filterData, userId).subscribe({
      next: (response: ResponseForReport<CategoryReport>) => {
        if (response.responseObject != undefined && response.responseObject != null) {
          saveAs(this.exportData.base64ToBlob(response.responseObject), 'userReport_' + this.formatedDate);
        }

        this.snackBar.open(response.message, 'Close',
          { duration: 3000 }
        );
        this.isExcelBeingDownloaded.emit(false);
      },
      error: (err) => {
        this.isExcelBeingDownloaded.emit(false);
        this.snackBar.open(err.message, 'Close', { duration: 3000 });
      }
    })
  }

  excelExportButtonStatus(value: any) {
    this.isExcelExporting = value;
    if (value) {
      this.exportButtonText = 'Exporting... ';
    } else {
      this.exportButtonText = 'Export Timesheet';
    }
  }

  onView(element: any) {
    this.router.navigate(['/home/timesheet'], {
      queryParams: {
        userId: element.userId,
        workDate: element.workDate
      }
    });
  }

  onFilter(): void {
    this.getUserReport();
  }

  clearFilter() {
    this.filterForm.reset({ workDate: '', categoryIds: [], activityIds: [], userIds: [], startDate: moment(), endDate: moment() });
    this.getUserReport();
  }

  formatWorkDetails(details: string): SafeHtml {
    if (!details) return '';
    const lines = details
      .split('\n')
      .map(line => `<div>• ${line}</div>`);
    return this.sanitizer.bypassSecurityTrustHtml(lines.join(''));
  }

  getTotalHours(): number {
  return this.userReport.reduce(
    (total, report) => total + Number(report.noOfHours || 0),
    0
  );
}
}
